import React from 'react';
import { formatCurrency } from '../utils/currencyFormatter';
export function RequisitionList({
  requisitions,
  onApprove,
  onConvertToPO,
  onAutoConvert,
  locale = 'en-US'
}) {
  return <ul className="divide-y divide-gray-200" data-id="element-15355">
      {requisitions.length === 0 ? <li className="py-4 px-6 text-center text-gray-500" data-id="element-15356">
          No requisitions found
        </li> : requisitions.map(requisition => <li key={requisition.id} className="px-4 py-4 sm:px-6 hover:bg-gray-50" data-id="element-15357">
            <div className="flex items-center justify-between" data-id="element-15358">
              <div data-id="element-15359">
                <p className="text-sm font-medium text-indigo-600 truncate" data-id="element-15360">
                  {requisition.id} - {requisition.name}
                </p>
                <p className="mt-1 text-sm text-gray-500" data-id="element-15361">
                  Vendor: {requisition.vendor}
                </p>
              </div>
              <div className="ml-6 flex-shrink-0 flex" data-id="element-15362">
                <p className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800" data-id="element-15363">
                  {requisition.status}
                </p>
              </div>
            </div>
            <div className="mt-2 sm:flex sm:justify-between" data-id="element-15364">
              <div className="sm:flex" data-id="element-15365">
                <p className="flex items-center text-sm text-gray-500" data-id="element-15366">
                  <svg className="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-id="element-15367">
                    <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" data-id="element-15368" />
                  </svg>
                  Created on {requisition.date}
                </p>
              </div>
              <div className="mt-2 flex items-center text-sm text-gray-500 sm:mt-0" data-id="element-15369">
                <svg className="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-id="element-15370">
                  <path fillRule="evenodd" d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" data-id="element-15371" />
                </svg>
                {formatCurrency(requisition.total, 'USD', locale)}
              </div>
            </div>
            {requisition.status === 'Pending Approval' && onApprove && <div className="mt-2 flex justify-end space-x-2" data-id="element-15372">
                <button onClick={() => onApprove(requisition.id)} className="inline-flex items-center px-2.5 py-1.5 border border-transparent text-xs font-medium rounded shadow-sm text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500" data-id="element-15373">
                  Approve
                </button>
                <button onClick={() => onAutoConvert(requisition.id)} className="inline-flex items-center px-2.5 py-1.5 border border-transparent text-xs font-medium rounded shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-15374">
                  Auto-Convert to PO
                </button>
              </div>}
            {requisition.status === 'Approved' && onConvertToPO && <div className="mt-2 flex justify-end" data-id="element-15375">
                <button onClick={() => onConvertToPO(requisition)} className="inline-flex items-center px-2.5 py-1.5 border border-transparent text-xs font-medium rounded shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-15376">
                  Convert to PO
                </button>
              </div>}
          </li>)}
    </ul>;
}